export default "__VITE_ASSET__CSBSEriH__"